export const SUCCESS  = 200
export const ERROR  = 999
export const GOOGLE_API  = '6LeTwbQgAAAAANiCbIiNZmEZGB2kXsdBzRwi0FsQ'
export const GOOGLE_API_SECRET  = '6LeTwbQgAAAAAGVQM2uW21MHwGkal3CKiL-7YPVQ'
export const GOOGLE_MAP_API = 'AIzaSyDB1VWcFVWZExdauD9_CnJBCAWPv05QeDo'
// AIzaSyAvEaJtEJVrovB5tQU7QQ6OKLr5L2NsRG0
// AIzaSyBKYWzsediFkY2BvgEYJJd6CiMc3m_Pt7o
//AIzaSyDhlc0Eu_bi-c18fcstMaUnL83CF-6Xs70

/** Google OAuth Client ID — lấy từ Google Cloud Console > APIs & Services > Credentials */
export const GOOGLE_CLIENT_ID ='420100940156-ngi37egsq7ojdkjk6gskngnmrq9o4oce.apps.googleusercontent.com'

/** Facebook Login App ID — lấy từ Meta Developers */
export const FACEBOOK_APP_ID = '1533520665475208'
export const FACEBOOK_API_VERSION = "v21.0"

export const SLIDE_BAR_URL  = []
export const FILE_EXCEL_TYPE = ["csv","xlsx","xlm","xlsb"]
export const ICON_EXCEL ="https://img.icons8.com/color/344/microsoft-excel-2019--v1.png"

/** Optional force tenant when host cannot resolve (local/dev). */
export const TENANT_CODE = process.env.VUE_APP_TENANT_CODE || ''

/** Main business API */
export const BASE_API = process.env.VUE_APP_BASE_API || ''

/** Config / settings API (tenant theme, menus, public config) */
export const CONFIG_API = process.env.VUE_APP_CONFIG_API || ''